import { useParams } from '@remix-run/react';
import { useAtomValue } from 'jotai';
import { $PoiInfo } from 'shared/atoms';
import { useTranslation } from 'react-i18next';

export const usePoiDesc = (): { title: string; description: string } => {
  const { t } = useTranslation();

  const { poi_id: poiId = '' } = useParams<{ poi_id: string }>();
  const { name } = useAtomValue($PoiInfo(poiId));

  const description = t('poi_description').replace('%s', name);

  const title = `${t('related_helmet_title').replace('%s', `#${name}`)}｜Lemon8`;

  return { title, description };
};
